<template>
    <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
      <div>
        <a-row :gutter="14">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-card :loading="loading.page">
              <div slot="title">
                Claim Ticket Recapitulation Manifest
                <small class="m-display-block m-text-small">
                  {{ source.header.no_rekap }}
                </small>
              </div>
              <a-popover slot="extra" trigger="focus" placement="bottom">
                <span slot="title">Select Action</span>
                <ul class="m-list-wrapper bordered" slot="content">
                  <li>
                    <a-button-group>
                      <a-button
                        @click="handlePrintManifest"
                        type="dashed"
                        icon="printer"
                        block
                        class="m-display-block"
                        :loading="loading.print"
                        >Cetak</a-button
                      >
                      <a-button
                        @click="handleExportManifest"
                        type="dashed"
                        icon="download"
                        block
                        class="m-display-block"
                        :loading="loading.export"
                        >Export</a-button
                      >
                    </a-button-group>
                  </li>
                  <li>
                    <a-button
                      :disabled="!(source.status_besar=='Revised' && source.header.tlc_create==getAuth.username)"
                      @click="handleShowEditRekap"
                      type="danger"
                      icon="edit"
                      class="m-width-full"
                      :loading="dataEdited.loading"
                    >
                      Edit
                    </a-button>
                  </li>
                  
                </ul>
                <a-button :size="getScreen ? 'small' : 'default'" icon="more" :loading="loading.print || dataEdited.loading">{{getScreen ? '' : 'Action'}}</a-button>
              </a-popover>
              <div class="m-card-body">
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title">Period</span>
                    <span class="m-list-desc">{{ source.header.periode }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Create By</span>
                    <span class="m-list-desc">{{ source.header.tlc_create }}</span>
                  </li>
                  <li v-if="source.header.jenis=='Luar Negeri'">
                    <span class="m-list-title">Exchange Rate</span>
                    <span class="m-list-desc">{{ formatCurrency('IDR',source.header.kurs) }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Description</span>
                    <span class="m-list-desc">{{ source.header.description }}</span>
                  </li>
                  <li>
                    <span class="m-list-title">Total Recapitulation</span>
                    <span class="m-list-desc">
                      <div>{{ formatCurrency('IDR',source.header.total_nilai) }}</div>
                    </span>
                  </li>
                  <li>
                    <span class="m-list-title">Document Support</span>
                    <span class="m-list-desc">
                      <a-button
                        v-if="source.header.file_doc_rekap_path"
                        @click="handleViewDoc(source.header.file_doc_rekap_path)"
                        class="margin-top"
                        type="dashed"
                        icon="eye"
                        >View Document</a-button
                      >
                      <span v-else>-</span>
                    </span>
                  </li>
                </ul>
              </div>
            </a-card>
  
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Detail list</h4>
                </div>
                <a-table
                  :rowKey="(record, index) => {return index;}"
                  :columns="columnsList"
                  :dataSource="source.transaction_list"
                  :pagination="pagination"
                  size="small"
                  class="table-dtl"
                  :scroll="{ x: 1000 }"
                  bordered
                >
                  <template slot="no" slot-scope="item,data,index">
                    {{ index+1 }}
                  </template>
                  <template slot="create_date" slot-scope="item">
                    {{ moment(item.tgl_buat).format(getStandartFormatDate) }} / {{ item.tlc_klaim_cc_tiket }} / {{ moment(item.tanggal_aksi).format(getStandartFormatDate) }}
                  </template>
                  <template slot="no_klaim" slot-scope="item">
                    <a href="#" @click="gotoManifest(item)">{{ item.no_klaim_cc_tiket }}</a>
                  </template>
                  <template slot="no_cc" slot-scope="item">
                    {{ item.no_cc }}
                  </template>
                  <template slot="qty_end_user" slot-scope="item">
                    {{ item.qty_end_user }}
                  </template>
                  <template slot="total_claim" slot-scope="item">
                    <span>{{ formatCurrency('IDR',item.total_claim) }}</span>
                  </template>
                  <template slot="action" slot-scope="item">
                    <div style="display:flex;justify-content:center">
                        <a-tooltip placement="topRight">
                            <template slot="title">
                            <span>View</span>
                            </template>
                            <a-button icon="eye" type="default" @click="showDtl(item)"></a-button>
                        </a-tooltip>
                    </div>
                </template>
                </a-table>
              </a-collapse-panel>
            </a-collapse>
  
            <a-card
              class="margin-top"
              :loading="loading.page"
              v-if="source.jenis !== 'manifest'"
            >
              <div slot="title">Manifest Actions</div>
  
              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Action">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option v-for="item in source.aksi" :key="item.aksi">{{
                      item.aksi
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleAction"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-card>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <Status :status="source.status_besar" />
                    <a-button
                      @click="historyToggle"
                      type="default"
                      size="small"
                      class="margin-right-small"
                    >
                      <a-icon type="history" />
                    </a-button>
                  </div>
                </div>
                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Creator - {{ source.header.tlc_create }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">{{ source.header.tgl_sppd }}</h4>
                      <span class="m-text-small" v-if="source.header.remark">{{
                        source.header.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">Created</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    color="green"
                    v-for="workflow in source.workflow"
                    :key="workflow.step_no"
                  >
                    <div class="m-timeline-title">
                      {{ workflow.actor }} - {{ workflow.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4
                        class="margin-remove"
                        v-if="workflow.tanggal_aksi !== null"
                      >
                        {{ workflow.tanggal_aksi }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Related Document</h4>
                </div>
                <a-list
                  itemLayout="horizontal"
                  :dataSource="source.dokumen_terkait"
                >
                  <Empty
                    v-if="
                      source.dokumen_terkait
                        ? source.dokumen_terkait.length <= 0
                        : source.dokumen_terkait
                    "
                  />
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                      <div
                        slot="title"
                        class="m-display-flex space-between align-middle"
                      >
                        <a @click="handleView(item)"
                          >{{ item.header }} | {{ item.pembuat }}</a
                        >
                        <Status
                          :class="!getScreen ? 'margin-remove' : ''"
                          :status="item.status"
                        />
                      </div>
  
                      <div
                        slot="title"
                        class="m-display-flex space-between align-middle"
                        v-if="item.no_pp"
                      >
                        <span>{{ item.no_pp }}</span>
                      </div>
                      <div slot="description" v-if="item.tgl_mulai_dinas">
                        <span
                          >{{
                            moment(
                              item.tgl_mulai_dinas,
                              getStandartFormatDate
                            ).format(getDefaultDateFormat)
                          }}
                          -
                          {{
                            moment(
                              item.tgl_selesai_dinas,
                              getStandartFormatDate
                            ).format(getDefaultDateFormat)
                          }}</span
                        >
                      </div>
                      <div slot="description">
                        <div class="m-width-full">
                          <a-tooltip
                            class="ant-tooltip-inner"
                            placement="top"
                            :title="
                              item.deskripsi
                                ? item.deskripsi
                                : 'Tidak ada deskripsi'
                            "
                          >
                            <span class="ant-description-ellipses">{{
                              item.deskripsi
                                ? item.deskripsi
                                : "Tidak ada deskripsi"
                            }}</span>
                          </a-tooltip>
                        </div>
                      </div>
                      <div
                        slot="title"
                        v-if="item.value_transaksi && item.rest_api !== 'sppds'"
                      >
                        <span class="m-timeline-title">{{
                          formatCurrency(item.currency, item.value_transaksi)
                        }}</span>
                      </div>
                    </a-list-item-meta>
                  </a-list-item>
                </a-list>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
        </a-row>
      </div>
  
      <a-modal v-model="visible.history" @ok="historyToggle" :footer="null">
        <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>
  
        <ul class="m-list-wrapper bordered">
          <li v-for="history in source.history" :key="history.id_notifikasi">
            <div v-if="history.aksi === '1' || history.aksi === '3'">
              <div class="m-display-flex space-between">
                <h3 class="margin-remove m-list-title">
                  {{ history.as_from }} | {{ history.tlc_from }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
            <div v-else-if="history.aksi === '2' || history.aksi === '4'">
              <div class="m-display-flex space-between">
                <h3
                  class="margin-remove m-list-title"
                  v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
                >
                  {{ history.as_from }} | {{ history.tlc_from }}
                </h3>
                <h3 class="margin-remove m-list-title" v-else>
                  {{ history.as_to }} | {{ history.tlc_to }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
          </li>
        </ul>
      </a-modal>
  
      <DialogManifestEditRekap v-if="visible.editRekap" :visible="visible.editRekap" :detail="dataEdited.source"/>

      <DialogDetil
        v-if="dialog.visibleDtl"
        :visible="dialog.visibleDtl"
        :dtl="dialog.dataDtl"
      />
    </div>
  </template>
  <script>
  import { mapGetters } from "vuex";
  import DialogManifestEditRekap from "./DialogManifestEditRekap.vue";
  import DialogDetil from "./DialogDetil.vue";
  import GlobalMethod from "@/mixins/GlobalMethod.js";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import HandleRoute from "@/mixins/HandleRoute";
  import moment from "moment";
  import axios from "axios";
  
  export default {
    name: "ManifestRekapKlaimTiket",
    components: {DialogManifestEditRekap, DialogDetil},
    mixins: [HandleRoute, CurrencyFormat, GlobalMethod],
    props: ["id"],
    data(){
      const columnsList = [
        {
          title: "#",
          key: "no",
          width: "50px",
          align: "center",
          scopedSlots: { customRender: "no" },
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Created Date / TLC / Approved Date",
          key: "create_date",
          width: "150px",
          align: "center",
          scopedSlots: { customRender: "create_date" },
          sorter: (a, b) => a.tgl_buat - b.tgl_buat,
        },
        {
          title: "Claim No",
          key: "no_klaim",
          width: "180px",
          align: "center",
          scopedSlots: { customRender: "no_klaim" },
          sorter: (a, b) => a.no_klaim_cc_tiket - b.no_klaim_cc_tiket,
        },
        {
          title: "Credit Card No",
          key: "no_cc",
          width: "180px",
          align: "left",
          scopedSlots: { customRender: "no_cc" },
          sorter: (a, b) => a.no_cc - b.no_cc,
        },
        // {
        //   title: "Incentive Value",
        //   key: "incentive",
        //   align: "right",
        //   scopedSlots: { customRender: "incentive" },
        //   sorter: (a, b) => a.total_ins_pd - b.total_ins_pd,
        // },
        {
          title: "Qty End User",
          key: "qty_end_user",
          width: "100px",
          align: "center",
          scopedSlots: { customRender: "qty_end_user" },
          sorter: (a, b) => a.qty_end_user - b.qty_end_user,
        },
        {
          title: "Total Claim",
          key: "total_claim",
          width: "180px",
          align: "right",
          scopedSlots: { customRender: "total_claim" },
          sorter: (a, b) => a.total_claim - b.total_claim,
        },
        {
          title: "Action",
          key: "action",
          width: "100px",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ];
  
      return {
        columnsList,
        loading: {
          page: false,
          print: false,
          export: false
        },
        dataEdited: {
          source: null,
          loading: false
        },
        source: {
          header: [],
          history: [],
          dokumen_terkait: [],
          transaction_list: [],
          status_besar: '-',
          workflow: [],
          aksi:[],
        },
        visible: {
          history: false,
          editRekap: false,
        },
        pagination: {
          onChange: (page) => {},
          pageSize: 4,
          size: "small",
        },
        dialog:{
          visible: false,
          visibleDtl: false,
          dataDtl: [],
        },
      }
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
    },
    created() {
      Event.$on("closeDiagEditRec", this.closeDiagEditRec);
      Event.$on("confirmMessageReturn", this.handleActionProcess);
      Event.$on("closeDiagDtl", this.closeDialogDtl);
      Event.$on("fetchData", this.fetch);
    },
    beforeDestroy() {
      Event.$off("closeDiagEditRec", this.closeDiagEditRec);
      Event.$off("confirmMessageReturn", this.handleActionProcess);
      Event.$off("closeDiagDtl", this.closeDialogDtl);
      Event.$off("fetchData", this.fetch);
    },
    mounted(){
      this.fetch()
    },
    computed: {
      ...mapGetters([
        "getScreen",
        "getAuth",
        "getStandartFormatDate",
        "getDateTimeFormat",
        "getDefaultDateFormat"
      ]),
    },
    methods:{
      moment,
      fetch(){
        this.loading.page = true
        this.asyncAxiosGet("rekap_tiket",
          this.getAuth,
          {
            id_rekap_cc_tiket: this.id
          }
        ).then((res) => {
          this.source = res
        
          this.loading.page = false
        }).catch((err) => {
          this.loading.page = false
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
      },
      handleViewDoc(file_path){
        const url = this.$serviceUrl + file_path;
        window.open(url, "_blank");
      },
      historyToggle(e) {
        e.stopPropagation();
        this.visible.history = !this.visible.history;
      },
      handleShowEditRekap(e){
        e.stopPropagation();
  
        this.dataEdited.loading = true
        this.asyncAxiosGet("rekap_tiket/edit",
          this.getAuth,
          {
            id_rekap_cc_tiket: this.id
          }
        ).then((res) => {
          this.dataEdited.source = res
          this.dataEdited.source.dtl.forEach(element => {
            element['checked'] = (element.cek=='1' ? true : false)
          });
          this.dataEdited.loading = false
          this.visible.editRekap = true
        }).catch((err) => {
          this.dataEdited.loading = false
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
      },
      closeDiagEditRec(){
        this.visible.editRekap = false
      },
      handleAction() {
        this.confirmMessage("confirm-save");
      },
      handleActionProcess() {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }
  
          let data = new FormData();
          data.append("id_rekap_cc_tiket", this.id);
          data.append("status", values.aksi);
          data.append("remark", values.catatan ? values.catatan : "");
  
          this.asyncAxiosPost("rekap_tiket/approval","formdata", this.getAuth,data)
            .then(() => {
              this.displayMessage("success");
              //this.$router.go();
              this.$router.push({ name: "rekapKlaimTiketList", params: {} });
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      },
      handlePrintManifest(){
        this.loading.print = true
        axios({
          method: "get",
          url: this.$serviceUrl + "rekap_tiket/cetak",
          params: {
            id_rekap_cc_tiket: this.id
          },
          responseType: "blob",
          processData: false,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.loading.print = false
        })
        .catch(() => {
        });
      },
      fitToColumn(arrayOfArray) {
        // get maximum character of each column
        console.log('arrayOfArray', arrayOfArray)
        return arrayOfArray.map((a, i) => {console.log(a[i]); return ({ wch: Math.max(...arrayOfArray.map(a2 => {console.log(a2);return (`${a2[i]}` ? `${a2[i]}`.toString().length : 0)})) })});
      },
      handleExportManifest(){
        let data_export = [];
        if(this.source.transaction_list.length>0){
          this.source.transaction_list.forEach((item,index)=> {
            data_export.push({
              "No" : index+1,
              "Created Data / TLC" : moment(item.tgl_buat).format(this.getStandartFormatDate) + " / " + item.tlc_buat,
              "No LKPD / SPPD" : item.no_pdlk ? item.no_pdlk : item.no_sppd,
              "Assignee" : item.tlc + " \\ " + item.nama,
              "Total Days" : item.hari,
              "Total LKPD Incentive" : item.total_ins_pd / item.hari,
            })
          });
          const workbook = this.$XLSX.utils.book_new();
          const worksheet = this.$XLSX.utils.json_to_sheet(data_export);
  
          /* Calculate maximum width for each column :: auto width*/
          const columnSizes = data_export.reduce((acc, row) => {
            Object.keys(row).forEach((key, i) => {
              const headertextLength = key.length;
              const rowtextLength = row[key].toString().length
              const value = row[key] ? (headertextLength > rowtextLength ? headertextLength : rowtextLength) : 0;
              if (!acc[i] || value > acc[i]) {
                acc[i] = value;
              }
            });
            return acc;
          }, []);
          worksheet['!cols'] = columnSizes.map(width => ({ wch: width + 2 }));
  
          this.$XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          this.$XLSX.writeFile(workbook, "Rekap_LKPD_"+this.source.header.no_rekap+".xlsx");
        }else{
          this.displayMessageValue("error-basic", 'Data is Empty!');
        }
      },
      gotoManifest(params){
        const route = this.$router.resolve({
              name: "manifest_klaim_tiket_hrd",
              params: {
                id: params.id_klaim_cc_tiket
              },
            });
            window.open(route.href, "_self");
      },

      async showDtl(item){
        this.loading.dtl = true
        this.loading.key = item.id_klaim_cc_tiket
        await this.asyncAxiosGet("rekap_tiket/detail", this.getAuth, {
            id_klaim_cc_tiket: item.id_klaim_cc_tiket
        })
        .then((res) => {
          this.loading.dtl = false
          this.dialog.dataDtl = res
          this.dialog.visibleDtl = true
        })
        .catch(() => {
          this.loading.dtl = false
        });
      },

      closeDialogDtl(){
        this.dialog.visibleDtl = false
      },
    }
  }
  </script>
  <style lang="less">
  .table-dtl{
    th{
      text-align: center!important;
    }
  }
  </style>